export const APP_EVENT = {
  willSuspendEventKey: 'willSuspend',
  didResumeEventKey: 'didResume',
};
